import client from './api';

const KEY = 'pusubet_ref';
// Alt bayi daveti (?sub=) referanstan bağımsızdır: üye bir bayinin oyuncusu
// olmadan da onun alt bayisi olmak üzere kaydolabilir.
const SUB_KEY = 'pusubet_sub';
// Bu sekme oturumunda sayılmış ziyaret (kod:bağlantı). Sayfa yenilemesi ve
// site içi gezinme aynı ziyarettir; tıklama bir kez sayılır (sunucu da aynı
// ziyaretçiyi 30 dakika içinde ikinci kez saymaz).
const VISIT_KEY = 'pusubet_ref_visit';
const DEFAULT_DAYS = 30;
const CODE_RE = /^[A-Z0-9_-]{1,16}$/;

const cleanCode = (value) => {
  const code = String(value || '').trim().toUpperCase();
  return CODE_RE.test(code) ? code : '';
};

const readStored = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.code || (parsed.expires && Date.now() > parsed.expires)) {
      localStorage.removeItem(key);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

/**
 * URL'deki ?ref=XXXXX parametresini yakalar, doğrular ve saklar.
 * Kayıt formu daha sonra getRef() ile bu kodu payload'a ekler.
 */
export const captureRef = async () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const sub = cleanCode(params.get('sub'));
    const code = cleanCode(params.get('ref') || params.get('referral'));
    if (!code && !sub) return null;

    const link0 = cleanCode(params.get('l'));
    const visit = `${code}:${link0}`;
    if (code) {
      // Aynı ziyaret: kod zaten saklandı (ya da ilk çağrı saklıyor); sayaç
      // ve doğrulama tekrarlanmaz.
      let seen = false;
      try { seen = sessionStorage.getItem(VISIT_KEY) === visit; } catch { /* yok sayılır */ }
      if (seen) return code;
    }
    // İşaret, ağ çağrısından **önce** konur: aynı yüklemede ikinci kez
    // çalışan efekt (React StrictMode) ikinci bir tıklama göndermez.
    if (code) {
      try { sessionStorage.setItem(VISIT_KEY, visit); } catch { /* yok sayılır */ }
    }

    let days = DEFAULT_DAYS;
    try {
      const { data: terms } = await client.get('/affiliate/terms');
      if (terms?.cookie_days) days = Number(terms.cookie_days);
    } catch { /* varsayılan süre kullanılır */ }
    const expires = Date.now() + days * 24 * 60 * 60 * 1000;

    if (sub) {
      localStorage.setItem(SUB_KEY, JSON.stringify({ code: sub, expires }));
    }
    if (!code) return null;

    // Kodun geçerliliğini doğrula ve tıklamayı say. ``l`` bayinin bağlantı
    // oluşturucusunda ürettiği izleme bağlantısıdır; tıklama ve kayıt o
    // bağlantının (ve pazarlama kaynağının) altına yazılır.
    let link = link0;
    try {
      const query = link ? `?l=${encodeURIComponent(link)}` : '';
      const { data } = await client.get(`/affiliate/track/${encodeURIComponent(code)}${query}`);
      if (!data.valid) return null;
      link = cleanCode(data.link) || '';
    } catch {
      // Sunucuya ulaşılamazsa kodu yine sakla; kayıtta tekrar doğrulanır.
    }
    localStorage.setItem(KEY, JSON.stringify({ code, link, expires }));
    return code;
  } catch {
    return null;
  }
};

/** Saklanan (ve süresi geçmemiş) referans kodunu döndürür. */
export const getRef = () => readStored(KEY)?.code || null;

/** Kayıt gövdesine eklenecek atıf alanları (``ref``, ``ref_link``, ``sub``). */
export const getRefPayload = () => {
  const payload = {};
  const ref = readStored(KEY);
  if (ref?.code) {
    payload.ref = ref.code;
    if (ref.link) payload.ref_link = ref.link;
  }
  const sub = readStored(SUB_KEY);
  if (sub?.code) payload.sub = sub.code;
  return payload;
};

/** Kayıt tamamlandıktan sonra kodu temizler. */
export const clearRef = () => {
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem(SUB_KEY);
  } catch { /* yok sayılır */ }
};

/** Affiliate'in paylaşacağı davet linkini üretir. */
export const buildRefLink = (code) =>
  `${window.location.origin}/?ref=${encodeURIComponent(code || '')}`;
